/** Product copy only. These rows never determine connection availability or access. */
export interface IntegrationContent {
  appKey: string;
  locale: string;
  description: string;
  readCapabilities: string[];
  writeCapabilities: string[];
}

const aliases: Readonly<Record<string, string>> = {
  helpscout: 'help_scout',
  judgeme: 'judge_me',
  mcp: 'custom_mcp',
  figma_oauth: 'figma',
  figma_api_key: 'figma',
  klaviyo_oauth: 'klaviyo',
  mailchimp_oauth: 'mailchimp',
  insider_one_oauth: 'insider_one',
  adobe_commerce: 'magento',
};

export function normalizeIntegrationContentKey(tool: string): string {
  const key = tool.trim().toLowerCase().replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');
  return aliases[key] || key;
}

export function resolveIntegrationContent(
  rows: readonly IntegrationContent[], tool: string, locale: string,
): IntegrationContent | null {
  const key = normalizeIntegrationContentKey(tool);
  const language = /^zh(?:-|$)/i.test(locale) ? 'zh-CN' : 'en';
  const matches = rows.filter(row => normalizeIntegrationContentKey(row.appKey) === key);
  return matches.find(row => row.locale === language)
    || matches.find(row => row.locale === 'en') || null;
}
